import { useMemo } from 'react'

const useManagersFormOptions = (formik, statusData) => {
  const statusOptions = useMemo(
    () =>
      statusData?.list?.filter(s => s.isEnabled).map(s => ({ label: s.name, value: s.id })) ?? [],
    [statusData?.list]
  )

  const statusValue = useMemo(() => {
    const statusList = statusData?.list?.find(s => s.id === formik.values.status)
    return statusList ? { label: statusList.name ?? '', value: formik.values.status } : null
  }, [statusData?.list, formik.values.status])

  return { statusOptions, statusValue }
}

export default useManagersFormOptions
